import * as React from 'react';

import { createTheme, nelnetTaskTheme, UnifiThemeProvider } from '@nelnet/unifi-components-react';

const TaskTheme: React.FunctionComponent = ({ children }) => {
  const taskTheme = createTheme(nelnetTaskTheme);
  return <UnifiThemeProvider theme={taskTheme}>{children}</UnifiThemeProvider>;
};

export default TaskTheme;
